import React from 'react';

import { RadioCircle, RadioInput, RadioLabel, RadioOption } from './RadioCommons';

interface RadioButtonProps {
    checked: boolean;
    value: string | number;
    label: JSX.Element;
    onClick: () => void;
}

export const RadioButton = ({ label, value, checked, onClick }: RadioButtonProps) => {
    const id = `radio-${value}-${Date.now()}`;

    return (
        <RadioOption htmlFor={id}>
            <RadioInput type="radio" id={id} value={value} onClick={onClick} />
            <RadioCircle $checked={checked} />
            <RadioLabel>{label}</RadioLabel>
        </RadioOption>
    );
};
